export default __webpack_public_path__ + "static/media/531367701.a32e6884.jpg";